/**
 * theme/buildInfo.ts —— **关于**（§7：版本／构建提交／构建时间；**只读**）。
 *
 * 来源＝构建期注入（`vite.config.ts` 的 `define.__XG_BUILD__`），**非取数**（不打网络、不读远端）。
 * 缺注入（如单测直跑源码） ⇒ 回退常量（不假装有值，显式标注 unknown/dev）。
 */
export interface BuildInfo {
  version: string;
  commit: string;
  time: string;
}

declare const __XG_BUILD__: BuildInfo | undefined;

export const BUILD_INFO: BuildInfo = (() => {
  if (typeof __XG_BUILD__ !== "undefined" && __XG_BUILD__) return __XG_BUILD__;
  return { version: "dev", commit: "unknown", time: "unknown" };
})();

/** 三键只读呈现行（§7「关于」组） */
export function aboutLines(info: BuildInfo = BUILD_INFO): Array<{ key: string; label: string; value: string }> {
  return [
    { key: "version", label: "版本", value: info.version },
    { key: "build_commit", label: "构建提交", value: info.commit },
    { key: "build_time", label: "构建时间", value: info.time },
  ];
}
